var Draggable = Draggable || {};
var hashHelper = hashHelper || {};
var platformCheck = platformCheck || {};
var Power0 = Power0 || {};
var site = site || {};
var Spinner = Spinner || {};
var TimelineMax = TimelineMax || {};
var TweenMax = TweenMax || {};
var elementScrollProgress = elementScrollProgress || {};
var YT = YT || {};

(function ($) {
  Drupal.behaviors.boutiqueAerinLandingFormatterV2 = {
    attach: function (context) {
      // DOM
      var $window = $(window);
      var $body = $('body');
      var $boutique = $('.js-boutique-aerin-landing-formatter-v2', context);
      var $videoModal = $boutique.find('.video_container');
      // LOGIC
      var platformVars = platformCheck({
        target: $boutique[0],
        mobileSize: 767,
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });
      var videoVars = {
        youtubeAPIReady: false,
        scrubberUpdateTimer: undefined,
        volumeSlider: undefined,
        volumeControlFadeout: undefined,
        player: undefined
      };

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // BEGIN: Events
        $window
          .on('platformcheck-update', function (e) {
            // LOGIC
            var flag = e.originalEvent.detail.flag;

            // Updates mobile state via class
            function toggleMobile() {
              if ($boutique.hasClass('mobile')) {
                $boutique.removeClass('mobile');
                $window.trigger('desktopLostMobile');
              } else {
                $boutique.addClass('mobile');
                $window.trigger('desktopGainedMobile');
              }
            }

            // Updates orientation state via class
            function toggleOrientation() {
              if (platformVars.orientation) {
                $boutique.addClass('js-ipad-portrait');
              } else if (platformVars.orientation === false) {
                $boutique.removeClass('js-ipad-portrait');
              }

              $window.trigger('orientationChanged');
            }

            // Desktop mobile width detection
            if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
              toggleMobile();
            }

            if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
              toggleOrientation();
            }
          });

        // Hide title on mouse enter to prevent tooltips
        // Unhide on mouse leave
        $boutique.find('a')
          .on('mouseenter', function () {
            // DOM
            var $this = $(this);
            // LOGIC
            var title = $this.attr('title');

            $this.data('title', title);
            $this.removeAttr('title');
          })
          .on('mouseleave', function () {
            // DOM
            var $this = $(this);
            // LOGIC
            var title = $this.data('title');

            if (typeof title !== 'undefined') {
              $this.attr('title', title);
            }
          });
        // END: Events

        // BEGIN: Video Handling
        (function () {
          // DOM
          var $volumeKnob = $videoModal.find('.volume-slider .circle');
          // LOGIC
          var volumeControlFadeout;
          var volumeSlider;

          // Helper function to be hooked up to an interval that updates scrubber with current video progress
          function youtubeUpdateHandler() {
            var duration;
            var currentTime;
            var progress;

            if (typeof videoVars.player === 'undefined' || typeof videoVars.player.getDuration !== 'function') {
              return;
            }

            duration = videoVars.player.getDuration();
            currentTime = videoVars.player.getCurrentTime();
            progress = currentTime / duration;

            $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
          }

          function hideVolumeSlider() {
            if (volumeControlFadeout !== 'undefined') {
              clearTimeout(volumeControlFadeout);
            }

            volumeControlFadeout = setTimeout(function () {
              TweenMax.to($videoModal.find('.volume_btn .volume-slider'), 0.5, {
                opacity: 0,
                display: 'none',
                clearProps: 'all',
                onComplete: function () {
                  $videoModal.find('.volume_btn').removeClass('active');
                }
              });

              if (typeof volumeControlFadeout !== 'undefined') {
                clearTimeout(volumeControlFadeout);
              }

              volumeControlFadeout = undefined;
            }, 5000);
          }

          // BEGIN: Init
          volumeSlider = Draggable.create($volumeKnob, {
            bounds: $volumeKnob.parent(),
            type: 'top',
            onDrag: function () {
              // LOGIC
              var progress = 1 - Math.abs(this.y / this.maxY);

              if (typeof videoVars.player !== 'undefined') {
                videoVars.player.setVolume(100 * progress);
              } else {
                $videoModal.find('video')[0].volume = progress;
              }

              hideVolumeSlider();
            }
          })[0];

          // Initialize and set up Youtube variables and functionality
          // Functionality is encapsulated because elements here aren't expected to be used elsewhere
          (function () {
            // DOM
            var tag = document.createElement('script');
            var firstScriptTag = document.getElementsByTagName('script')[0];

            window.onYouTubeIframeAPIReady = function () {
              // DOM
              videoVars.youtubeAPIReady = true;

              $window.trigger('youtubeready');
            };

            tag.src = 'https://www.youtube.com/iframe_api';
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          })();

          // Also set volume to 0 to allow autoplay
          // NOTE: Mute disables a ton USE AT OWN RISK
          if (platformVars.isMobile) {
            $videoModal.find('video')[0].volume = 0;
            $videoModal.find('video')[0].muted = false;
          }
          // END: Init

          // BEGIN: Events
          // Open youtube modal then play youtube video via API
          $boutique.find('.video-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $videoTag = $videoModal.find('video');
            var $videoYoutube = $videoModal.find('.video');
            // LOGIC
            var videoID = $this.data('youtube-id');
            var videoURLMP4 = $this.data('video-url-mp4');
            var videoURLWEBM = $this.data('video-url-webm');
            var isVideoSet = false;

            e.stopPropagation();
            e.preventDefault();

            $window.trigger('videomodalopened');

            // Must have a youtube ID otherwise attempt to play normal video
            if (typeof videoID !== 'undefined' && videoID.trim().length !== 0) {
              $videoTag.css({ display: 'none' });
              $videoYoutube.css({ display: 'block' });

              TweenMax.fromTo($videoModal, 0.5, {
                opacity: 0,
                display: 'none'
              }, {
                opacity: 1,
                display: 'block',
                className: '+=active'
              });

              videoVars.player = new YT.Player($videoYoutube[0], {
                height: '360',
                width: '640',
                videoId: videoID,
                playerVars: {
                  autoplay: 0, // Autoplay is handled via on ready
                  rel: 0,
                  showinfo: 0,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  controls: 0,
                  start: 1,
                  playsinline: 1,
                  enablejsapi: 1
                },
                events: {
                  // Mute needed for mobile autoplay
                  onReady: function () {
                    if (!platformVars.isDesktop && platformVars.isMobile) {
                      videoVars.player.mute();
                    }
                    videoVars.player.playVideo();
                  },
                  onStateChange: function (e) {
                    var state = e.data;

                    // Unstarted/Play/Buffering
                    // Reveal video
                    if ((state === -1 || state === 1 || state === 3) && !platformVars.isMobile) {
                      videoVars.scrubberUpdateTimer = window.setInterval(youtubeUpdateHandler, 500);

                      $videoModal.find('.play_btn').addClass('active');

                      // Ended
                      // Hide video
                    } else if (state === 0) {
                      $videoModal.find('.close_btn').trigger('click');
                    } else {
                      $videoModal.find('.play_btn').removeClass('active');
                    }
                  }
                }
              });
            } else {
              $videoTag.css({ display: 'block' });
              $videoYoutube.css({ display: 'none' });
              // Clear URLS
              $videoTag.find('source').attr('src', '');

              if (/\.(mp4){1}$/gi.test(videoURLMP4)) {
                $videoTag.find('source[type="video/mp4"]').attr('src', videoURLMP4);
                isVideoSet = true;
              }

              if (/\.(webm){1}$/gi.test(videoURLWEBM)) {
                $videoTag.find('source[type="video/webm"]').attr('src', videoURLWEBM);
                isVideoSet = true;
              }

              // Attempt to load everything
              $videoTag[0].load();

              if (isVideoSet) {
                $videoTag.one('canplay', function () {
                  this.play();
                });

                TweenMax.fromTo($videoModal, 0.5, {
                  opacity: 0,
                  display: 'none'
                }, {
                  opacity: 1,
                  display: 'block',
                  className: '+=active'
                });
              }
            }
          });

          // Clear this event call on elproduct success, prevents regular links in moodboardTiles from being inoperable
          $boutique.find('.el-product_shop-now-container a').on('click', function (e) {
            e.stopPropagation();
          });

          // Video play button click
          $videoModal.find('.play_btn').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $video = $videoModal.find('video');

            e.preventDefault();

            if (!platformVars.isMobile) {
              // Clear existing video update timers
              if (typeof videoVars.scrubberUpdateTimer !== 'undefined') {
                clearInterval(videoVars.scrubberUpdateTimer);
              }

              videoVars.scrubberUpdateTimer = setInterval(youtubeUpdateHandler, 500);
            }

            if (typeof videoVars.player !== 'undefined') {
              if ($this.hasClass('active')) {
                videoVars.player.pauseVideo();
                $this.removeClass('active');
              } else {
                videoVars.player.playVideo();
                $this.addClass('active');
              }
            } else {
              if ($this.hasClass('active')) {
                $video[0].pause();
              } else {
                $video[0].play();
              }
            }
          });

          $videoModal.find('.volume_btn').on('click', function (e) {
            // DOM
            var $this = $(this);

            e.preventDefault();

            if ($this.hasClass('active')) {
              $this.removeClass('active');
            } else {
              $this.addClass('active');

              hideVolumeSlider();
            }
          });

          // Volume slider click handling
          $videoModal.find('.volume_btn .line-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $volumeKnob = $this.find('.circle');
            // LOGIC
            var progress = ($this.offset().top - $window.scrollTop() - e.clientY) / $this.height();

            e.stopPropagation();
            e.preventDefault();

            progress = Math.abs(Math.round(progress * 100) / 100);

            TweenMax.set($volumeKnob, { top: volumeSlider.maxY * progress });

            if (typeof videoVars.player !== 'undefined') {
              videoVars.player.setVolume(100 * progress);
            } else {
              $videoModal.find('video')[0].volume = progress;
            }

            volumeSlider.update(true);
            volumeSlider.startDrag(e);
            volumeSlider.endDrag(e);

            hideVolumeSlider();
          });

          // Video scrubber click
          $videoModal.find('.scrubber-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $video = $videoModal.find('video');
            // LOGIC
            var position = e.clientX - $this.offset().left;
            var duration;
            var progress = position / $this.width();

            e.preventDefault();

            $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');

            if (typeof videoVars.player !== 'undefined' && typeof videoVars.player.getDuration === 'function') {
              duration = videoVars.player.getDuration();
              videoVars.player.seekTo(duration * progress);
            } else {
              $video[0].currentTime = $video[0].duration * progress;
            }
          });

          // Video fullscreen click
          $videoModal.find('.full_btn').on('click', function (e) {
            // DOM
            var $video = $videoModal.find('video');

            function requestFullScreenHelper($target) {
              var requestFullScreen;

              if ($target.length === 0) {
                return;
              }

              requestFullScreen = $target[0].requestFullScreen || $target[0].mozRequestFullScreen || $target[0].webkitRequestFullScreen;
              requestFullScreen.call($target[0]);
            }

            e.preventDefault();

            // Must have an available player to do stuff
            if (typeof videoVars.player !== 'undefined') {
              requestFullScreenHelper($videoModal.find('iframe'));
            } else {
              requestFullScreenHelper($video);
            }
          });

          // Video close button click
          $videoModal.find('.close_btn').on('click', function (e) {
            // DOM
            var $video = $videoModal.find('video');

            e.stopPropagation();
            e.preventDefault();

            // Clear existing video update timers
            if (videoVars.scrubberUpdateTimer !== 'undefined') {
              window.clearInterval(videoVars.scrubberUpdateTimer);
            }

            if (typeof videoVars.player !== 'undefined') {
              videoVars.player.destroy();
              videoVars.player = undefined;
            } else if (!$video[0].paused) {
              $video[0].pause();
              $video[0].currentTime = 0;
            }

            TweenMax.to($videoModal, 0.5, {
              opacity: 0,
              display: 'none',
              className: '-=active'
            });
          });

          $videoModal.find('video')
            .on('timeupdate', function () {
              var duration;
              var currentTime;
              var progress;

              duration = this.duration;
              currentTime = this.currentTime;
              progress = currentTime / duration;

              $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
            })
            .on('ended', function () {
              $videoModal.find('.close_btn').trigger('click');

              if (platformVars.isMobile) {
                if (typeof this.webkitExitFullScreen === 'function') {
                  this.webkitExitFullScreen();
                }
              }
            })
            .on('play playing', function () {
              $videoModal.find('.play_btn').addClass('active');
            })
            .on('pause', function () {
              $videoModal.find('.play_btn').removeClass('active');
            })
            .on('volumechange', function () {
              // DOM
              var $volumeButton = $videoModal.find('.volume_btn');
              // LOGIC
              var volume = this.volume * 100;

              // Reset
              $volumeButton.removeClass('vol-0 vol-1 vol-2 vol-3');

              if (volume === 0) {
                $volumeButton.addClass('vol-0');
              } else if (volume <= 33) {
                $volumeButton.addClass('vol-1');// ;
              } else if (volume <= 66) {
                $volumeButton.addClass('vol-2');
              } else if (volume > 66) {
                $volumeButton.addClass('vol-3');
              }
            })
            .trigger('volumechange');
          // END: Events
        })();
        // END: Video Handling

        // BEGIN: Scroll Handling
        // Functionality should only happen once preload completes
        $window.on('aerin-preload-complete', function () {
          // Marks active sections
          $window.on('scroll', _.throttle(function () {
            elementScrollProgress($boutique.find('section').toArray(), {
              activeClass: 'js-active',
              visibleClass: 'js-visible',
              eventGainVisible: 'gainedVisible',
              eventGainCurrent: 'gainedActive'
            });
          }, 100));

          $window.trigger('scroll');
        });
        // END: Scroll Handling

        // BEGIN: Mobile Footer Nav
        (function () {
          // DOM
          var $self = $('#section-footer');
          // LOGIC
          var animation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          animation
            .fromTo($self, 0.5, { opacity: 0 }, { opacity: 1 });
          // END: Init

          // BEGIN: Events
          $self.on('gainedActive', function () {
            animation.play();
          });
          // END: Events
        })();
        // END: Mobile Footer Nav

        // BEGIN: Carousel Handling
        // NOTE: Animations should be handled through slideHasGainedActive
        // TODO: Switch to and integrate Slick
        (function () {
          // DOM
          // Ignore carousels within custom MPP
          var $carouselContainers = $boutique.find('.carousel_container').filter(function () {
            return $(this).closest('.custom-mpp').length !== 1;
          });
          // LOGIC
          var carouselTarget = '.carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : '');
          var carouselSettings = {
            increment: '100%',
            offset: '0%',
            ignoreTargets: '.ignore',
            debug: false,
            useGSAP: false,
            duration: 1,
            callbackAnimation: function () {
              // DOM
              var $newSlide;
              var $otherSlides;
              // LOGIC
              var _this = this;
              var animation = new TimelineMax();

              $newSlide = _this.slides[0];
              $otherSlides = $newSlide.siblings();

              $newSlide.trigger('slideWillGainActive');
              $otherSlides.trigger('slideWillLoseActive'); // Signal that the last slide will lose active after animation

              animation
                .to($otherSlides, 0.5, {
                  opacity: 0,
                  display: 'none',
                  position: 'absolute',
                  className: '-=active'
                })
                .to($newSlide, 0.5, {
                  opacity: 1,
                  display: 'block',
                  position: 'relative',
                  className: '+=active'
                }, '0')
                .add(function () {
                  $newSlide.trigger('slideHasGainedActive');
                  _this.$target.trigger('carousel_updated', $newSlide.index());
                });
            }
          };

          function initCarousels() {
            $carouselContainers.each(function () {
              // DOM
              var $this = $(this);
              var $carousel = $this.find(carouselTarget);
              var $carouselDotContainer = $this.find('.carousel_pagination ul');

              carouselSettings.$dot_container = $carouselDotContainer;
              carouselSettings.$dot_template = $carouselDotContainer.find('.template');

              // Enable carousel and controls for mobile and landscape iPad
              if ($carousel.children().length > 1) {
                $carousel.elCarousel(carouselSettings);
                $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'block' });

              // Otherwise hide controls and make "first" slide the active slide
              } else {
                // Carousel children needs active to be visible
                $carousel.children().first().addClass('active');
                $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
              }

              // Hide pagination for mobile only
              if (platformVars.isMobile) {
                $this.find('.carousel_pagination').css({ display: 'none' });
              }
            });
          }

          // BEGIN: Init
          initCarousels();
          // END: Init

          // BEGIN: Events
          // Global stopper for blank a tags in carousels
          $carouselContainers.find('a[href=""]').on('click', function (e) {
            e.preventDefault();
          });

          // Carousel progression via arrow click
          $carouselContainers.find('.carousel_pagers li').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $carousel = $this.closest('.carousel_container').find(carouselTarget);

            e.preventDefault();

            if ($this.hasClass('previous')) {
              $carousel.elCarouselPrev();
            } else if ($this.hasClass('next')) {
              $carousel.elCarouselNext();
            }
          });

          // Carousel navigation via dot nav click
          $carouselContainers.find('.carousel_pagination ul li').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $carousel = $this.closest('.carousel_container').find(carouselTarget);
            // LOGIC
            var index = $this.index() - 1;

            e.preventDefault();

            $this.addClass('active').siblings().removeClass('active');

            $carousel.elCarouselTo(index);
          });

          // Dot nav update on carousel update
          $carouselContainers.on('carousel_updated', function (e, index) {
            $(this).find('.carousel_pagination ul li').eq(index + 1).addClass('active').siblings().removeClass('active');
          });

          // Carousel progression via swipe
          $carouselContainers.find(carouselTarget).swipe({
            swipeLeft: function () {
              $(this).elCarouselNext();
            },
            swipeRight: function () {
              $(this).elCarouselPrev();
            },
            excludedElements: 'button, input, select, textarea, .noSwipe',
            preventDefaultEvents: false
          });

          // Carousel progression via keyboard directional key press
          $window
            .on('keydown', function (e) {
              // Find carousels in active sections
              $carouselContainers.each(function () {
                // DOM
                var $this = $(this);
                var $carousel = $this.find(carouselTarget);

                // Container section must be active
                if ($this.closest('section.active').length === 0) {
                  return;
                }

                switch (e.which) {
                  // Previous
                  case 37:
                    $carousel.elCarouselPrev();
                    break;

                    // Next
                  case 39:
                    $carousel.elCarouselNext();
                    break;
                }
              });
            });

          // END: Events
        })();
        // });
        // END: Carousel Handling
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: Aerin - Landing Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // Functionality only occurs on the landing page
        if (!$boutique.hasClass('landing')) {
          return;
        }

        // BEGIN: Section 1
        (function () {
          // DOM
          var $self = $('#section-landing');
          var $video;
          // LOGIC
          var animation = new TimelineMax({ paused: true });
          var videoHasAutoplay = false;

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          $video = $self.find('video');
          videoHasAutoplay = typeof $video.attr('autoplay') !== 'undefined';

          animation
            .to($self.find('.mp4-container'), 0.5, { opacity: 1 })
            .to($self.find('.background'), 0.5, { opacity: 0 }, '0');
          // END: Init

          // BEGIN: Events
          // Play intro animation once video starts playing
          $video.on('playing', function () {
            animation.play();
          });

          $videoModal.find('.close_btn').on('click', function (e) {
            var $targetVideo = $video.filter(platformVars.isMobile ? '.mobile' : '.desktop');

            e.preventDefault();

            if ($video.length !== 0 && videoHasAutoplay) {
              $targetVideo[0].play();
            }
          });

          $window.on('videomodalopened', function () {
            $video.each(function () {
              this.pause();
            });
          })
            .one('aerin-preload-complete', function () {
              var $targetVideo = $video.filter(platformVars.isMobile ? '.mobile' : '.desktop');

              if ($video.length !== 0 && videoHasAutoplay) {
                $targetVideo[0].play();
              }
            })
            .on('desktopGainedMobile desktopLostMobile orientationChanged', function () {
              var $targetVideo = $video.filter(platformVars.isMobile ? '.mobile' : '.desktop');

              $video.each(function () {
                this.pause();
              });

              if ($video.length !== 0 && videoHasAutoplay) {
                $targetVideo[0].play();
              }
            });

          // Clear intro animation if desktop/mobile changes
          $window.on('desktopGainedMobile desktopLostMobile', function () {
            animation.kill();
            $self.find('.mp4-container').removeAttr('style');
            $self.find('.background').removeAttr('style');
          });
          // END: Events
        })();
        // END: Section 1

        // BEGIN: Section 2, 3, 4
        (function () {
          // DOM
          $('#section-2, #section-3, #section-4').each(function () {
            // DOM
            var $self = $(this);
            var $background = $self.find('.background');
            var $carousel = $self.find('.carousel_container > div');
            var $carouselSlides = $carousel.find('.tile-content');
            // LOGIC
            var introAnimation = new TimelineMax({ paused: true });
            var introAnimationPlayed = false;

            // BEGIN: Init
            if (!platformVars.isMobile) {
              introAnimation.fromTo($background, 0.5, { opacity: 0 }, { opacity: 1 });
            }

            // Create animation per slide
            $carouselSlides.each(function () {
            // DOM
              var $this = $(this);
              var $tileDescriptionContent = $this.find('.tile-description').find('h3' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' + 'h2' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' + (platformVars.isMobile ? '.mobile' : '.desktop') + ' > p,' + 'div.mobile,' + '.el-product_shop-now-container');
              var animation = new TimelineMax({ paused: true });

              animation
                .staggerFromTo($tileDescriptionContent, 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25)
                .addCallback(function () {
                  $this.removeData('animation');
                })
                .addPause();

              $this.data('animation', animation);
            });
            // END: Init

            // BEGIN: Events
            // Play slide animation if available
            $carouselSlides.on('slideHasGainedActive', function () {
            // DOM
              var $this = $(this);
              // LOGIC
              var animation = $this.data('animation');

              if (typeof animation === 'undefined' || (!$self.hasClass('active') && !introAnimationPlayed)) {
                return;
              }
              animation.play(0);
            });

            // Section active event
            $self.on('gainedActive', function () {
            // DOM
              var $activeSlide = $carouselSlides.eq(0);
              // LOGIC
              var animation = $activeSlide.data('animation');

              if (typeof animation === 'undefined') {
                return;
              }

              // If intro animation for slide has been played already, just play slide animation
              if (introAnimationPlayed && animation.progress() === 0) {
                animation.play();
              // If intro animation hasn't been played yet, play that first before slide animation
              } else {
                // Add a once only animation
                introAnimation.add((function () {
                  var once = false;

                  return function () {
                    if (once) {
                      return;
                    }

                    once = true;
                    animation.play();
                  };
                })());

                introAnimation.play();
                introAnimationPlayed = true;
              }
            });

            $self.on('deeplink', function (e, data) {
              if (data.deeplinkData.length > 1) {
                $carousel.elCarouselTo(parseInt(data.deeplinkData[1]));
              }
            });

            // Clear intro animation if desktop/mobile changes
            // Clear animation from all slides
            $window
              // Complete all animations if platform changes
              .on('desktopGainedMobile desktopLostMobile', function () {
                introAnimation.progress(1);
                introAnimationPlayed = true;

                $carouselSlides.each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var animation = $this.data('animation');

                  if (typeof animation !== 'undefined') {
                    animation.progress(1);
                  }

                  $this.find('.tile-description').find('h3, h2, .mobile > p, .desktop > p, .el-product_shop-now-container').removeAttr('style');
                });

                $carouselSlides.eq(0).addClass('active').siblings().removeClass('active');
              });
          // END: Events
          });
        })();
        // END: Section 2, 3, 4
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: Aerin - Landing Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: Aerin - board Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $moodboardTiles = $('.moodboard-tile');
        // LOGIC
        var introAnimation = new TimelineMax({ paused: true });

        // Moodboard tiles must exist
        if ($moodboardTiles.length === 0) {
          return;
        }

        // BEGIN: Init
        // Build animation for each tile
        $moodboardTiles.each(function () {
          // DOM
          var $this = $(this);
          var $tileWrapper = $this.find('.tile-wrapper');
          var $tileContent = $this.find('.tile-card');
          // LOGIC
          var tileAnimation = new TimelineMax();

          // Animation
          tileAnimation
            .addLabel('start')
            .set($tileWrapper, { rotationY: 0 })
          // .set($tileContent, {opacity: 0, display: 'none'})
            .addPause()
            .addLabel('show', '+=0.1')
            .set($this, { className: '-=js-opening' }, '+=0.1')
            .set($this, { className: '+=js-opening' }, '+=0.1')
            .fromTo($tileWrapper, 0.5, { rotationY: 0 }, {
              rotationY: -180,
              immediateRender: false
            })
            .set($tileContent, { visibility: 'visible' })
            .from($tileContent, 0.2, {
              height: 0,
              immediateRender: false,
              clearProps: 'height'
            })
            .staggerFromTo($tileContent.children(), 0.5, { opacity: 0 }, { opacity: 1 }, 0.10, '-=0.2')
            .set($this, { className: '-=js-opening' })
            .set($this, { className: '+=js-open' })
            .addPause()
            .addLabel('hide', '+=0.1')
            .set($this, { className: '+=js-closing' }, '+=0.1')
            .set($this.find('.tile-image'), { rotationY: 180 })
            .to($tileContent.children(), 0.5, { opacity: 0 })
            .to($tileContent, 0.5, {
              opacity: 0,
              height: 0,
              immediateRender: false
            }, '-=0.5')
            .to($this.find('.tile-card-placeholder'), 0.5, { opacity: 0 })
            .set($this, { className: '-=js-closing' })
            .set($this, { className: '-=js-open' })
            .set($this.find('.tile-image'), { clearProps: 'all' })
            .set($tileWrapper, { rotationY: 0 })
            .addPause()
            .addLabel('end', '+=0.1');

          $this.data('animation', tileAnimation);
        });

        introAnimation
          .staggerFromTo($moodboardTiles, 1.5, { opacity: 0 }, {
            opacity: 1,
            clearProps: 'all',
            ease: Power0.easeNone
          }, 0.1)
          .staggerFrom($('.section-container header').children(), 1, { opacity: 0 }, 0.2, '0');
        // END: Init

        // BEGIN: Events
        // Once only intro animation trigger
        $window.one('aerin-preload-complete', function () {
          introAnimation.play();
        });

        // Opens the target tile and closes other tiles
        $moodboardTiles
          .on('click', function (e) {
            // DOM
            var $this = $(this);
            // LOGIC
            var animation = $this.data('animation');

            e.preventDefault();

            if (typeof animation === 'undefined' || $(e.target).closest('.close-button').length !== 0) {
              return;
            }

            if (!$this.hasClass('js-open')) {
              animation.play('show');
            }

            $this.siblings('.js-open, .js-opening').find('.close-button').trigger('click');
          });

        // Closes the tile associated with the button
        $moodboardTiles.find('.close-button').on('click', function (e) {
          // DOM
          var $tile = $(this).closest('.moodboard-tile');
          // LOGIC
          var animation = $tile.data('animation');

          e.preventDefault();

          if (typeof animation === 'undefined') {
            return;
          }
          animation.pause();
          animation.tweenTo('end');
        });

        // Clear this event call on elproduct success, prevents regular links in moodboardTiles from being inoperable
        $moodboardTiles.find('.el-product_shop-now-container a').on('click', function (e) {
          e.stopPropagation();
        });
        // END: Events

        // BEGIN: Init
        $boutique.elproduct({
          target: '.el-product_shop-now',
          prodArray: (function () {
            // Build product list from moodboard buttons
            var products = [];

            $moodboardTiles.each(function () {
              // LOGIC
              var productID = $(this).find('.el-product_shop-now-container a').attr('data-product');

              if (typeof productID === 'string' && productID.trim().length !== 0) {
                products.push(productID);
              }
            });

            return products;
          })(),
          onSuccess: function () {
            // Implement button handling
            $moodboardTiles.find('.el-product_shop-now-container a').off('click').on('click', function (e) {
              // DOM
              var $this = $(this);
              // LOGIC
              var productData = $this.data('product-data');

              // Adds product to cart or opens quickshop absed on class name
              function shopFunctionality() {
                if ($this.hasClass('add-to-bag')) {
                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: productData.skus[0].SKU_ID.replace(/[A-z]+/, ''),
                      PARENT_CAT_ID: productData.PRODUCT_ID
                    },
                    quantity: 1,
                    QTY: 1
                  });
                } else if ($this.hasClass('quickshop')) {
                  site.quickshop(productData);
                }
              }

              e.stopPropagation();

              // add-to-bag and quickshop classes skips normal link out functionality
              if ($this.hasClass('add-to-bag') || $this.hasClass('quickshop')) {
                e.preventDefault();

                // Product data must exist
                if (typeof site === 'undefined' || typeof productData === 'undefined') {
                  return;
                }

                shopFunctionality();
              }
            });
          }
        });
        // END: Init
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: Aerin - Moodboard Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $loader = $('.aerin_v2 .loader');
        var $deeplinkSection;
        var $targetImages;
        // LOGIC
        var deeplinkData = hashHelper.get();
        var spinnerOptions = {
          lines: 17, // The number of lines to draw
          length: 0, // The length of each line
          width: 5, // The line thickness
          radius: 26, // The radius of the inner circle
          scale: 1, // Scales overall size of the spinner
          corners: 1, // Corner roundness (0..1)
          color: '#ffffff', // #rgb or #rrggbb or array of colors
          opacity: 0.5, // Opacity of the lines
          rotate: 0, // The rotation offset
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1, // Rounds per second
          trail: 30, // Afterglow percentage
          zIndex: 2e9, // The z-index (defaults to 2000000000)
          className: 'spinner', // The CSS class to assign to the spinner
          top: '50%', // Top position relative to parent
          left: '50%', // Left position relative to parent
          shadow: false, // Whether to render a shadow
          hwaccel: true, // Whether to use hardware acceleration
          position: 'absolute' // Element positioning
        };
        var spinner = new Spinner(spinnerOptions).spin($loader[0]);

        // Default to first section in page
        if (deeplinkData.length === 0) {
          $deeplinkSection = $boutique.find('section').first();
        } else {
          // Attempt to find section without '#section-'
          $deeplinkSection = $boutique.find('#' + deeplinkData[0]);

          if ($deeplinkSection.length === 0) {
            // Attempt to find section with '#section-'
            $deeplinkSection = $boutique.find('#section-' + deeplinkData[0]);

            // Default to first section
            if ($deeplinkSection.length === 0) {
              $deeplinkSection = $boutique.find('section').first();
            }
          }
        }

        // Get all images before the target section images as well, as content may be sized to loaded images
        $targetImages = $deeplinkSection.add($deeplinkSection.prevAll()).find('img');
        $targetImages.FreeLoader({
          callback: function () {
            // LOGIC
            var animation = new TimelineMax({ delay: 1 });

            // Mark boutique as loaded
            $boutique.addClass('loaded');

            //  Load other (boutique) images normally
            $boutique.find('img').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var imageLink = $this.attr('data-src');

              if (typeof imageLink === 'string' && imageLink.trim().length !== 0) {
                $this.attr('src', imageLink);
              }
            });

            spinner.stop();

            animation
              .to($loader, 1, {
                opacity: 0,
                display: 'none',
                onComplete: function () {
                  $window.trigger('aerin-preload-complete');

                  if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                    $deeplinkSection.trigger('deeplink', { deeplinkData: deeplinkData });
                  }

                  $window.trigger('scroll');
                  $window.trigger('loadAnimationComplete');
                }
              });

            // MPP has no deeplink
            if (!$boutique.hasClass('mpp')) {
              animation.addCallback(function () {
                var scrollValue = 0;

                // Get Deeplink scroll amount
                function getDeeplinkScrollTarget() {
                  // If the section content is larger than window, scroll to top
                  if ($deeplinkSection.height() > $window.height() || platformVars.isMobile) {
                    scrollValue = $deeplinkSection.offset().top - $('header').height() - (platformVars.isMobile ? $('#aerin_nav').height() : 0);

                  // Otherwise scroll so that the section content is in the middle of the page
                  } else {
                    scrollValue = $deeplinkSection.offset().top - ($window.height() - $deeplinkSection.height()) / 2 - $('header').height();
                  }

                  if ($deeplinkSection.is($boutique.find('section').first())) {
                    scrollValue = 0;
                  }
                }

                // Get target scroll value if a deep link section exists
                if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                  getDeeplinkScrollTarget();
                }

                if (scrollValue !== 0) {
                  TweenMax.to($window, 1, {
                    scrollTo: {
                      y: scrollValue,
                      autoKill: false
                    },
                    onComplete: function () {
                      $window.trigger('scroll');
                      $window.trigger('loadAnimationComplete');
                    }
                  });
                }
              });
            }
          }
        });
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
    }
  };
})(jQuery);
